import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import SignUp from "./components/auth/signUp";
import Login from "./components/auth/login";
import SignupComplete from "./components/auth/signUpComplete";
import { Authentication } from "./services/auth.utils";
import PageNotFound from "./components/utils/not-found";
import StripeProvider from "./components/auth/StripeProvider";

function App() {
  const tokenAuthentication = new Authentication();
  const isAuthenticated = tokenAuthentication.isAuthenticated();

  return (
    <div className="App">
      <StripeProvider>
        <Router>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<SignUp />} />
            <Route path="/complete" element={<SignupComplete />} />

            {/* Not-Found */}
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </Router>
      </StripeProvider>
    </div>
  );
}

export default App;
